module.exports = __webpack_public_path__ + "static/Human-Graphic-2f06db3598823706f0254dbf3ce01ee9.png";